import { render, staticRenderFns } from "./submit-dialog.vue?vue&type=template&id=7c95e0ac&"
import script from "./submit-dialog.vue?vue&type=script&lang=js&"
export * from "./submit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports